const FF = {
  PASSWORDLESS_AUTH_AFTER_CHECKOUT: 'oo-v3-passwordless-auth-after-checkout',
  PASSWORDLESS_AUTH_DURING_CHECKOUT: 'oo-v3-passwordless-auth-during-checkout',
  PASSWORDLESS_AUTH_KILL_SWITCH: 'oo-v3-passwordless-auth-kill-switch',
  ACCOUNT_PROFILE_LINKING: 'oo-v3-account-profile-import',
  DELETE_ACCOUNT: 'oo-v3-account-deletion',
  GLOBAL_GIFTCARDS: 'oo-global-giftcards-enabled',
  SHOW_CHARGE_INFO: 'oo-v3-show-charge-info',
  DAAS_INTEGRATION: 'oo-daas-integration',
  GIFT_CARD_REDEMPTION: 'oo-v3-gift-card-redemption',
  CHECKOUT_FULFILLMENT: 'oo-v3-checkout-fulfillment',
  NV5_SEO: 'oo-v3-nv5-seo',
  MENU_GROUP_DESCRIPTION: 'oo-v3-menu-group-description',
  PIZZA_MENU_MANAGEMENT: 'oo-v3-pizza-menu-management',
  BANNER_IMAGE_FIX: 'oo-v3-banner-image-fix',
  BIRDS_EYE_VIEW: 'oo-v3-birds-eye-view',
  USE_SERVICE_AVAILABILITY: 'oo-v3-use-service-availability',
  USE_DO_MENUS: 'oo-v3-use-do-menus',
  ALLOW_APOLLO_RETRY: 'oo-v3-allow-apollo-retry',
  GUEST_FEEDBACK: 'oo-v3-guest-feedback',
  CART_UPSELLS: 'oo-cart-upsell', // non-standard oo-v3 flag, but it's what's used on the back-end to determine if enabled for a restaurant
  MEAL_SELECTOR: 'oo-v3-meal-selector',
  MENU_ITEM_SORT: 'oo-v3-menu-item-sort',
  FLOATING_SEARCH_BUTTON: 'oo-v3-floating-search-button',
  PROMO_BANNER: 'oo-v3-display-promo-banners',
  COMBINED_MENU_GROUPS: 'oo-v3-combined-menu-groups',
  ALLOW_REDEMPTION_OF_BIRTHDAY_REWARDS: 'oo-v3-birthday-rewards-refactor',
  EDIT_MODE: 'oo-v3-edit-mode'
}

export { FF }
